import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {BufferStates} from 'Navigation';
import {Optional} from 'util/Types';

import {GetBioentityAnalyticsDashboardQuery} from '../data/__generated/GetBioentityAnalyticsDashboardQuery';
import EmbeddedAnalyticsDashboardTabState from './EmbeddedAnalyticsDashboardTabState';

/**
 * Create EmbeddedAnalyticsDashboardTabState from GetBioentityAnalyticsDashboardQuery data
 *
 * Return null if the entity does not have an accessible analyticsDashboardLink.
 */
export function createEmbeddedDashboardTab(
  data: GetBioentityAnalyticsDashboardQuery
): EmbeddedAnalyticsDashboardTabState | null {
  if (!isInaccessible(data.bioentity) && data.bioentity.tagSchema != null) {
    const analyticsDashboardLink = data.bioentity.tagSchema.analyticsDashboardLink;
    if (analyticsDashboardLink != null) {
      return new EmbeddedAnalyticsDashboardTabState({
        analyticsDashboardLink,
        itemId: data.bioentity.id,
      });
    }
  }
  return null;
}

/**
 * Add embedded dashboard to the end of the right buffer
 */
export function addEmbeddedDashboardTab(
  buffers: BufferStates,
  embeddedDashboardTab: Optional<EmbeddedAnalyticsDashboardTabState>
): void {
  if (embeddedDashboardTab != null) {
    buffers.addTab(embeddedDashboardTab, {side: 'right', active: false});
  }
}
